import { DBDeliveryTypeEnum } from '@prisma/client';

export const DELIVERY_TYPE_NAMES = {
  [DBDeliveryTypeEnum.DHL]: 'Dhl',
  [DBDeliveryTypeEnum.DPD]: 'Dpd',
  [DBDeliveryTypeEnum.TRUCK]: 'Truck',
  [DBDeliveryTypeEnum.DROPSHIPPING]: 'Dropshipping',
};
